import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button} from '@mui/material';
import Grid from '@mui/material/Grid2';

import StatePicker from 'components/StatePicker/StatePicker';
import _ from 'lodash';
import { serializeQueryParamsIntoStr } from '../../../commonFunctions';
import { usertype_permissions } from '../../../enums/PermissionEnums';

// Import Zustand store
import { useAppStore } from '../../../stores';

interface Permission {
  name: string;
}

interface IAffiliateSearchProps {
  onRowClick?: (data: unknown) => void;
}

const AffiliateSearch: React.FC<IAffiliateSearchProps> = (props) => {
  const navigate = useNavigate();

  // Zustand store
  const permissions = Object.values(useAppStore((state) => state.user.permissions)) as Permission[];

  const [searchPayload, setSearchPayload] = useState({
    locationStateAbr: '',
    affiliateNbr: '',
    affiliateName: '',
    affiliateTypeId: '',
  });

  const [isAffiliateNbrError, setIsAffiliateNbrError] = React.useState(false);

  const [isStateFedPresident, setIsStateFedPresident] = React.useState(false);

  React.useEffect(() => {
    // set if they are state fed president
    if (_.find(permissions, (p) => p.name == usertype_permissions.StateFed)) {
      setIsStateFedPresident(true);
    }
  }, []);

  const updateSearchFields = (e: { target: { name: string; value: string } }) => {
    if (e.target.name === 'affiliateNbr') {
      const { value } = e.target;
      let error = false;
      if (value.length === 0) {
        error = false;
      } else {
        const regexp = new RegExp(/^[a-zA-Z0-9]{5}$/);
        error = !String(value).match(regexp) ? true : false;
      }
      setIsAffiliateNbrError(error);
    }
    setSearchPayload({
      ...searchPayload,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const params = serializeQueryParamsIntoStr(searchPayload);

    navigate({
      pathname: '/affiliate-info/search-results',
      search: params,
    });
  };

  return (
    <Grid container size={{ xs: 12 }}>
      <Grid size={{ xs: 12 }} style={{ marginBottom: '0.5em' }}>
        <h2>Compliance Search</h2>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <form onSubmit={handleSubmit} method={'post'}>
          <Grid
            container
            size={{ xs: 12 }}
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={3}
          >
            <Grid size={{ xs: 12, md: 3 }}>
              <TextField
                fullWidth={true}
                variant="outlined"
                name="affiliateName"
                label="Affiliate Name"
                onChange={updateSearchFields}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <TextField
                fullWidth={true}
                variant="outlined"
                name="affiliateNbr"
                label="Affiliate Number"
                onChange={updateSearchFields}
                error={isAffiliateNbrError}
                helperText={
                  isAffiliateNbrError
                    ? "Please enter a 5 digit number (e.g. '00010' not '10')"
                    : ''
                }
              />
            </Grid>
            {!isStateFedPresident && (
              <Grid size={{ xs: 12, md: 3 }}>
                <StatePicker
                  id={'affiliate-search-state-dropdown'}
                  label={'Affiliate State'}
                  defaultValue={''}
                  displayDefaultValue={true}
                  name="locationStateAbr"
                  onChange={updateSearchFields}
                />
              </Grid>
            )}

            <Grid size={{ xs: 12, md: 3 }}>
              <TextField
                fullWidth={true}
                variant="outlined"
                name="affiliateTypeId"
                label="Affiliate Type"
                onChange={updateSearchFields}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }} className="text-center">
              <Button
                fullWidth={true}
                className="btn btn-center"
                size="large"
                color="primary"
                variant="contained"
                type="submit"
                disabled={isAffiliateNbrError}
              >
                Search Affiliates
              </Button>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default AffiliateSearch;
